import { Link } from '@mui/material';

const COMPANY_ADVANCED_SEARCH_ENUMS_FILE_URL =
  'https://github.com/craft-machine/premium-portal/blob/main/src/components/CompanyAdvancedSearch/CompanyAdvancedSearchEnums.tsx';

const tooltips = {
  search_columns: (
    <span>
      Please use values from the <strong>AdvancedCompanySearchColumnsTypes</strong> enum found{' '}
      <Link href={COMPANY_ADVANCED_SEARCH_ENUMS_FILE_URL} target="_blank" rel="noreferrer" color="primary.light">
        here.
      </Link>
    </span>
  ),
  api_field_paths: (
    <span>
      API field paths that should be included in this criteria. These paths correspond to the API fields available in
      the system.
    </span>
  ),
};

export default tooltips;
